<template>
  <div class="map-container">
    <div id="map" ref="map"></div>
  </div>
</template>

<script>
import { mapService } from "@/services/map/mapService";
import { geopackageService } from "@/services/map/geopackageService";
import { scaleVisibilityService } from "@/services/layers/scaleVisibilityService";
import { attributeSelectionService } from "@/services/map/attributeSelectionService";

export default {
  name: "MapView",

  mounted() {
    const map = mapService.init("map");
    scaleVisibilityService.start(map, this.$store);
    attributeSelectionService.start(this.$store);
    geopackageService.restoreOfflineBasemap(mapService); // no-op sin flag; silencioso en fallo

    // Encuadre inicial automático: región del usuario si tiene una asignada;
    // si no, se conserva el encuadre nacional de mapService.init.
    const region = this.$store.getters.getUserRegion;
    console.log('[MapView] Datos de sesión (cookie session_public):', {
      region,
      permissions: this.$store.getters.getPermissions
    });
    if (region) {
      mapService.zoomToRegionExtent(region, { duration: 0 });
    }
  },

  beforeDestroy() {
    scaleVisibilityService.stop();
    attributeSelectionService.stopSync();
    mapService.destroy();
  }
};
</script>

<style scoped>
.map-container {
  width: 100%;
  height: 100%;
}

#map {
  width: 100%;
  height: 100%;
}
</style>
